import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

export const ContinuityAndDatesStep = () => {
  const { t } = useTranslation("workflow", { keyPrefix: "parts.rollForwardWizard" });

  // TODO: [SP-11687] replace placeholder with the Continuity and dates step
  return (
    <Typography variant="bodyRegular">
      {t("stepPlaceholder", { name: t("steps.continuityAndDates") })}
    </Typography>
  );
};
